import LayersAndResolutions from 'data/layers/LayersAndResolutions.json';
import dayjs from 'dayjs';
import { getEumetsatLayer } from 'services/homeService';
import betterWmsLayer from '../utils/leafletUtils/betterWmsLayer';


const defaultOpacity = 50;
const layerName = 'Products';
const mapServerURL = process.env.REACT_APP_MAP_SERVER_URL;
const srs = 'EPSG:3857';
const format_file = 'image/png';

async function createLeafletLayer(layerParameters, day, month, year, opacity, openNotification, handleError) {
    
    const layerOpacity = opacity ? opacity : defaultOpacity;

    const { fileName, provider, spaceResolution, timeResolution, predictionDay } = layerParameters;
    
    let newLayer;
    const eumetsatLayers = ["mdfvc", "mdfapar", "mlst", "mlst-as", "mgpp", "edlst", "frm", "mdmetv3", "metref"];
    if(eumetsatLayers.includes(provider)) {

        newLayer = await getEumetsatLayer(layerOpacity, provider, timeResolution, spaceResolution, year, month, day);

    } else {

        const mapServerLayerURL = `${mapServerURL}${fileName}`;
        const name = `${spaceResolution}_${timeResolution}_${year}_${month}_${day}`;

        newLayer = await new betterWmsLayer(mapServerLayerURL, {
            layers: layerName,
            transparent: true,
            format: format_file,
            srs: srs,
            version: '1.3.0',
            attribution: '',
            opacity: layerOpacity / 100,
            provider: provider,
            year: year,
            month: month,
            day: day,
            spaceResolution: spaceResolution,
            timeResolution: timeResolution,
            name: name,
            predictionDate: predictionDay ? // This is only used when managing meteorological predictions.
                dayjs(`${year}-${month}-${day}`).add(predictionDay, "day").format("YYYY_MM_DD") :
                `${year}_${month}_${day}`
        });

    }
        
    const layerDisplayName = fileName.split('/').pop().split('.')[0]; // Get a clean name for display

    newLayer.on('tileerror', () => {
        handleError(`This service is not currently available: ${layerDisplayName}`, layerDisplayName);
        //throw error;
    });

    return newLayer;
};

function addLeafletLayer(newLayer, mapRef, layerRefs) {
    layerRefs.current.push(newLayer);
    newLayer.addTo(mapRef.current);
    mapRef.current.invalidateSize();
};

function removeLeafletLayer(index, mapRef, layerRefs) {
    const layer = layerRefs.current[index];
    mapRef.current.removeLayer(layer);
    layerRefs.current = layerRefs.current.filter((_, i) => i !== index);
}

function updateLeafletLayer(updatedLayer, index, mapRef, layerRefs) {
    mapRef.current.removeLayer(layerRefs.current[index]);
    layerRefs.current[index] = updatedLayer;
    updatedLayer.addTo(mapRef.current);
}

function clearLeafletLayers(mapRef, layerRefs) {
    layerRefs.current.forEach((l) => mapRef.current.removeLayer(l));
    layerRefs.current = [];
}

function useLeafletLayerManager() {
    return {
        createLeafletLayer, addLeafletLayer, removeLeafletLayer,
        updateLeafletLayer, clearLeafletLayers
    };
}

export default useLeafletLayerManager;